function PeopleInvolve({ deal, getAgent }) {
  return (
    <div className="bg-white rounded-xl shadow p-6">
      <div className="border-b border-black/10 pb-3">
        <h3 className="text-lg font-semibold">People Involved</h3>
      </div>

      <div className="space-y-4 mt-3">
        {deal.status === "Approved" &&
          deal.splitdescription === "Referral to Outside Agent" &&
          deal.agentName != "" && (
            <div>
              <p className="text-sm text-gray-500">{"Agent"}</p>
              <p className="font-semibold">{deal.agentName}</p>
            </div>
          )}
        {deal.status === "Approved" && deal.splitdescription !== "No Split" && (
          <div>
            <p className="text-sm text-gray-500">
              {deal.splittype === "Referral" ? "Referral Agent" : "Agent"}
            </p>
            <p className="font-semibold">
              {deal.splitdescription === "Referral to Outside Agent"
                ? deal.thirdpartyagentName
                : deal.agentName}
            </p>
          </div>
        )}
        {deal.status === "Pending" && (
          <div>
            <p className="text-sm text-gray-500">Agent</p>
            <p className="font-semibold">{getAgent(deal)}</p>
          </div>
        )}

        {deal.teamleadName && (
          <div>
            <p className="text-sm text-gray-500">Team Lead</p>
            <p className="font-semibold">{deal.teamleadName}</p>
          </div>
        )}

        {deal.leadsource?.name && (
          <div>
            <p className="text-sm text-gray-500">Lead Source</p>
            <p className="font-semibold">{deal.leadsource.name}</p>
          </div>
        )}

        {deal.titleCompany && (
          <div>
            <p className="text-sm text-gray-500">Title (your side)</p>
            <p className="font-semibold">
              {deal.titleCompany}
              {deal.titleCloserName ? ` — ${deal.titleCloserName}` : ""}
            </p>
            {(deal.titleCloserEmail || deal.titleCloserPhone) && (
              <p className="text-sm text-gray-600">
                {[deal.titleCloserEmail, deal.titleCloserPhone]
                  .filter(Boolean)
                  .join(" · ")}
              </p>
            )}
          </div>
        )}

        {deal.otherTitleCompany && (
          <div>
            <p className="text-sm text-gray-500">Title (other side)</p>
            <p className="font-semibold">
              {deal.otherTitleCompany}
              {deal.otherTitleCloserName
                ? ` — ${deal.otherTitleCloserName}`
                : ""}
            </p>
            {(deal.otherTitleCloserEmail || deal.otherTitleCloserPhone) && (
              <p className="text-sm text-gray-600">
                {[deal.otherTitleCloserEmail, deal.otherTitleCloserPhone]
                  .filter(Boolean)
                  .join(" · ")}
              </p>
            )}
          </div>
        )}

      </div>
    </div>
  );
}

export default PeopleInvolve;
